import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("ux-checkbox", () => {
    it("should be checked and unchecked on click", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-checkbox input-id="checkbox" name="name-attr" label="label" value="testvalue"></ux-checkbox>`);
        const uxCheckbox = await page.find("ux-checkbox");
        let checkboxChecked = await page.findAll("ux-checkbox input:checked");
        let checkboxUnchecked = await page.findAll("ux-checkbox input:not(:checked)");
        const eventHandler = await page.spyOnEvent("uxCheckboxChange");
        await page.waitForChanges();
        expect(uxCheckbox).toHaveClass("hydrated");
        expect(checkboxChecked.length).toBe(0);
        expect(checkboxUnchecked.length).toBe(1);
        await uxCheckbox.click();
        await page.waitForChanges();
        expect(eventHandler).toHaveReceivedEventDetail({
            checked: true,
            inputId: "checkbox",
            name: "name-attr",
            value: "testvalue"
        });
        checkboxChecked = await page.findAll("ux-checkbox input:checked");
        checkboxUnchecked = await page.findAll("ux-checkbox input:not(:checked)");
        await page.waitForChanges();
        expect(checkboxChecked.length).toBe(1);
        expect(checkboxUnchecked.length).toBe(0);
        await uxCheckbox.click();
        await page.waitForChanges();
        expect(eventHandler).toHaveReceivedEventDetail({
            checked: false,
            inputId: "checkbox",
            name: "name-attr",
            value: "testvalue"
        });
        checkboxChecked = await page.findAll("ux-checkbox input:checked");
        checkboxUnchecked = await page.findAll("ux-checkbox input:not(:checked)");
        expect(checkboxChecked.length).toBe(0);
        expect(checkboxUnchecked.length).toBe(1);
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-checkbox error error-message="foo" label="test"></ux-checkbox>`);
        const el = await page.find("ux-checkbox");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("disabled should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-checkbox disabled label="test"></ux-checkbox>`);
        const el = await page.find("ux-checkbox");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should match to snapshot with some props", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-checkbox checked name="name-attr" value="testvalue"><i>test</i></ux-checkbox>`);
        const el = await page.find("ux-checkbox");
        const input = await page.find("input:checked");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
        expect(input).toEqualText("");
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-checkbox checked name="name-attr" value="testvalue"><i>test</i></ux-checkbox>`);
    });
});
